import React, {Component} from 'react';
import {inject, observer} from 'mobx-react';

@inject('GameStore')
@observer
export default class GameStep5 extends Component {

    render() {
        const winnerEl = this.props.GameStore.winners.map(
            (w, index) => {
                return (
                    <div className="team-winner" key={index}>
                        <div className={"team-name " + w.team.color}>{w.name || "Team "}</div>
                        <div className="team-score">{w.score || 0} Points</div>
                    </div>
                )
            }
        );

        return (
            <div className="step-5">
                <h1>Winner{ this.props.GameStore.winners.length > 1 && "s"}</h1>
                <div className="teams-winners">
                    {winnerEl}
                </div>
            </div>
        )
    }
};


// WEBPACK FOOTER //
// ./src/containers/Game/GameStep5.js